/* eslint-disable */
import store from '@/store'

export default {
  name: 'admin-projects',
  data: () => {
    return {
    }
  },

  created() {
  },
  computed: {
  },
  methods: {

  }
}
